export const MODIFICATION_TYPES = {
    AddIngredient: 'AddIngredient',
    RemoveIngredient: 'RemoveIngredient',
    SubstituteProduct: 'SubstituteProduct',
    ExtraAmount: 'ExtraAmount',
    StyleModification: 'StyleModification', // Added for drink style modifications like ice, rim, etc.
} as const;
export type ModificationType =
    (typeof MODIFICATION_TYPES)[keyof typeof MODIFICATION_TYPES];
